<template>
    <div class="submenu-wrap">
        <el-submenu
            v-if="
                !routeInfo.hide &&
                    routeInfo.children &&
                    routeInfo.children.length
            "
            :key="routeInfo.name"
            :index="routeInfo.id || routeInfo.path"
        >
            <template slot="title">
                <img
                    v-if="routeInfo.icon"
                    :src="routeInfo.icon"
                    class="menu-icon"
                    alt=""
                />
                <span class="menu-title">{{ routeInfo.menuName }}</span>
            </template>
            <template v-for="item in routeInfo.children">
                <sub-menu
                    v-if="!item.hide"
                    :key="item.id"
                    :routeInfo="item"
                    :basePath="item.path"
                    :onRouter="onRouter"
                />
            </template>
        </el-submenu>
        <el-menu-item
            v-else-if="!routeInfo.hide"
            :key="routeInfo.name"
            :index="routeInfo.id || routeInfo.path"
            @click="handlerRoute(routeInfo)"
        >
            <template slot="title">
                <img
                    v-if="routeInfo.icon"
                    :src="routeInfo.icon"
                    class="menu-icon"
                    alt=""
                />
                <span class="menu-title" v-if="!openNewWindow">{{
                    routeInfo.menuName
                }}</span>
                <a
                    v-else
                    class="menu-title"
                    target="_blank"
                    :href="tokenPath"
                    >{{ routeInfo.menuName }}</a
                >
            </template>
        </el-menu-item>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { pauseRouter, resumeRouter } from '@/common/store';
import { getSubAppNameByPath } from '@/utils/common';
export default {
    name: 'SubMenu',
    props: {
        routeInfo: {
            type: Object,
            default: () => {}
        },
        basePath: {
            type: String,
            default: ''
        },
        // 通知父组件的方法
        onRouter: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters(['allowRouterJump']),
        openNewWindow() {
            // 临时，移动端移动罗盘打开新窗口
            const { path } = this.routeInfo;
            let ismobile = navigator.userAgent.match(/AppleWebKit.*Mobile.*/i);
            let is = ismobile && path && path.match(/compass/);
            return !!is;
        },
        tokenPath() {
            // TODO: 域名不同
            return this.routeInfo.path;
        }
    },
    methods: {
        // 点击路由
        handlerRoute(routeInfo) {
            if (this.openNewWindow) {
                return;
            }
            let { path, meta = {} } = routeInfo;
            // 临时，移动罗盘pc端path
            if (path.match(/compass/)) {
                path = path.replace(/.*\.com/, '/any/bidc');
            }
            const subAppName = getSubAppNameByPath(this.$route.path);
            const allowRouterJump = this.allowRouterJump;
            let routerJumpPromise = null;
            if (
                subAppName &&
                allowRouterJump &&
                allowRouterJump.promise &&
                allowRouterJump.callback
            ) {
                const { promise, resolve, reject, callback } = allowRouterJump;
                callback(resolve, reject);
                routerJumpPromise = promise.then(() => {
                    return this.$router.push(path);
                });
            } else {
                routerJumpPromise = this.$router.push(path);
            }
            routerJumpPromise
                .then(() => {
                    this.onRouter({
                        id: routeInfo.id,
                        internal: meta && meta.internal ? true : false
                    });
                    resumeRouter();
                })
                .catch(() => {
                    this.onRouter({ action: 'cancel' });
                    pauseRouter(allowRouterJump.callback);
                });
        }
    }
};
</script>
<style lang="scss">
.el-menu--collapse .submenu-wrap .el-submenu__title .menu-title,
.el-menu--collapse .submenu-wrap .el-submenu__title .el-submenu__icon-arrow {
    display: none;
}
</style>
<style lang="scss" scoped>
.menu-icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    margin-right: 10px;
}
.menu-title {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgb(163, 164, 165);
    text-decoration: none;
    &:active {
        color: rgb(163, 164, 165);
        text-decoration: none;
    }
}
::v-deep {
    .el-submenu__icon-arrow {
        font-size: 12px;
        font-weight: 900;
    }
}
</style>
